define([
    'jQuery',
    'underscore',
    'library/fcse-travellerswidget/travellersWidget',
    'library/fcse-visibilitycontrol/visibilityControl',
    'library/fcse-compatibility/object'],
    function($, _, TravellersWidget, VisibilityControl, Object) {

        var TravellersWidgetExtended = function (element, options) {
            // Initialize Visibility Controls
            this._initVisibilityControls();
            
            var defaultOptions = {
                'disableClassName' : 'is-disabled'
            };
                            
            // Add default options and custom options
            this.addOptions(defaultOptions, options);
            
            // Call Constructor of parent class
            TravellersWidget.apply(this, arguments);
        };

        TravellersWidgetExtended.prototype = $.extend(Object.create(TravellersWidget.prototype), {
            _initVisibilityControls : function() {
                // Description
                this.descriptionCallerElement = $('[data-fcse-role="travellers--description"]', this.element);
                this.descriptionVisibilityControl = new VisibilityControl(this.descriptionCallerElement);

                // More Adults
                this.moreAdultsCallerElement = $('[data-fcse-role="travellers--moreadults"]', this.element);
                this.moreAdultsVisibilityControl = new VisibilityControl(this.moreAdultsCallerElement);
                this.moreAdultsCallerElement.on('click', $.proxy(this._moreAdultsCallerElementClick, this));

                // Adults Limit
                this.limitAdultsCallerElement = $('[data-fcse-role="travellerswidget"]', this.element);
                this.limitAdultsVisibilityControl = new VisibilityControl(this.limitAdultsCallerElement);

                // More Childs
                this.moreChildsCallerElement = $('[data-fcse-role="travellers--morechilds"]', this.element);
                this.moreChildsVisibilityControl = new VisibilityControl(this.moreChildsCallerElement);
                this.moreChildsCallerElement.on('click', $.proxy(this._moreChildsCallerElementClick, this));


                // Too many Childs Error
                this.tooManyChildsCallerElement = $('[data-fcse-role="travellers--toomanychilds"]', this.element);
                this.tooManyChildsVisibilityControl = new VisibilityControl(this.tooManyChildsCallerElement);
            },

            _moreAdultsCallerElementClick : function(e) {
                    // Stop Propagation / Prevent Default Handling
                    e.stopPropagation();
                    e.preventDefault();

                    // Close Dropdown
                    this.adultDropdown.closeDropdown();
            },

            _moreChildsCallerElementClick : function(e) {
                    // Stop Propagation / Prevent Default Handling
                    e.stopPropagation();
                    e.preventDefault();

                    // Close Dropdown
                    this.childDropdown.closeDropdown();
            },

            // Override onAdultsChange
            onAdultsChange : function(event) {
                // Call Parent-method
                TravellersWidget.prototype.onAdultsChange.call(this, event);

                if (this.adultDropdown.getValue() == this.option('moreAdultsValue')) {
                    // Open Visibility Control Target for Adults
                    this.moreAdultsVisibilityControl.openTarget(this.moreAdultsCallerElement, $(this.moreAdultsCallerElement.data('target')));
                } else {
                    this.moreAdultsVisibilityControl.closeTarget(this.moreAdultsCallerElement, $(this.moreAdultsCallerElement.data('target')), event);
                }

                if (this.adultDropdown.getValue() == 3 || this.adultDropdown.getValue() == 4 ) {
                    this.limitAdultsVisibilityControl.openTarget(this.limitAdultsCallerElement, $('#widget-travellers--adults-limit'));
                } else {
                    this.limitAdultsVisibilityControl.closeTarget(this.limitAdultsCallerElement, $('#widget-travellers--adults-limit'), event);
                }

                // Check Child Ages
                this._checkChildAges();
            },

            // Override onChildrenChange
            onChildrenChange : function(event) {
                // Call Parent-method
                TravellersWidget.prototype.onChildrenChange.call(this, event);

                // Set Default value to first item (which is for now '1') if no other dropdown item is selected
                $.each(this.ageChooserList, function(id, ageDropdown){
                    if (_.isUndefined(ageDropdown.getValue())) {
                        ageDropdown.setValue(1); // Set value to 1
                    }
                });

                // Open/Close Description
                if(this.childDropdown.getValue() >= 1) {
                    this.descriptionVisibilityControl.openTarget(this.descriptionCallerElement, $(this.descriptionCallerElement.data('target')));
                } else {
                    this.descriptionVisibilityControl.closeTarget(this.descriptionCallerElement, $(this.descriptionCallerElement.data('target')));
                }

                if (this.childDropdown.getValue() == this.option('moreChildsValue')) {
                    // Open Visibility Control Target for Childs
                    this.moreChildsVisibilityControl.openTarget(this.moreChildsCallerElement, $(this.moreChildsCallerElement.data('target')));
                    // close the description
                    this.descriptionVisibilityControl.closeTarget(this.descriptionCallerElement, $(this.descriptionCallerElement.data('target')));
                } else {
                    this.moreChildsVisibilityControl.closeTarget(this.moreChildsCallerElement, $(this.moreChildsCallerElement.data('target')));
                }

                // Check Child Ages
                this._checkChildAges();
            },

            _getParentFlyout : function() {
               return this.element.closest('[data-fcse-role="flyout"]');
            },

            _checkChildAges : function() {
                // Get All ChildAge-Dropdowns
                var currentValueFromUi = this.getValueFromUi();

                // Filter Children
                var childrenWithAgeSmallerTwo = _.filter(currentValueFromUi.children, function(num){ return num == 1; });

                if(childrenWithAgeSmallerTwo.length > currentValueFromUi.adults) {
                    // Handle too many Childss
                    this.tooManyChildsVisibilityControl.openTarget(this.tooManyChildsCallerElement, $(this.tooManyChildsCallerElement.data('target')));

                    $('[data-fcse-role="flyout--button-ok"]', this._getParentFlyout())
                                .attr('disabled', 'disabled')
                                .addClass(this.option('disableClassName'));
                } else {
                    this.tooManyChildsVisibilityControl.closeTarget(this.tooManyChildsCallerElement, $(this.tooManyChildsCallerElement.data('target')));

                    $('[data-fcse-role="flyout--button-ok"]', this._getParentFlyout())
                            .removeAttr('disabled')
                            .removeClass(this.option('disableClassName'));
                }
                $.each(this.ageChooserList, function(i, dropdown) {
                    var selected = $('.dropdown--option.is-selected', dropdown.element);
                    if (selected.length > 0) {
                        $('[data-fcse-role="dropdown--label"]', dropdown.element).html(selected.text());
                    }
                });
            },

            onChildAgeChange : function(event) {
                this._checkChildAges();
            },
            
            formatValue : function() {
                var val = this.getValueFromUi();
                var text = val.adults;
                
                if (val.adults != 1){
                    text += ' ' + this.option('adultLabelPlural');
                } else {
                    text += ' ' + this.option('adultLabel');
                }
                
                if (val.children.length != 1){
                    text += ', ' + val.children.length + ' ' + this.option('childLabelPlural');
                } else {
                    text += ', ' + val.children.length + ' ' + this.option('childLabel');
                }
                 return text;
            },

            /**
             * Validate data and show errors
             */
            isValid: function() {
                // Call Parent-method
                var result = TravellersWidget.prototype.isValid.call(this);

                if (this.adultDropdown.getValue() == this.option('moreAdultsValue')) {
                    // decrease adult number
                    this.adultDropdown.setValue(this.option('moreAdultsValue') - 1);
                }

                if (this.childDropdown.getValue() == this.option('moreChildsValue')) {
                    // decrease child number
                    this.childDropdown.setValue(this.option('moreChildsValue') - 1);
                    result = false;
                }

                return result;
            }
        });

        return TravellersWidgetExtended;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/travellers/travellersWidgetExtended.js